export default {
  AGREEMENTS: 'AGREEMENTS',
  AGREEMENTS_CHANGE_SUCCESS: 'AGREEMENTS_CHANGE_SUCCESS',
  BIRTH_DATE_CHANGE: 'BIRTH_DATE_CHANGE',
  BIRTH_DATE_CHANGE_SUCCESS: 'BIRTH_DATE_CHANGE_SUCCESS',
  CHANGE_GENDER: 'CHANGE_GENDER',
  CHANGE_GENDER_SUCCESS: 'CHANGE_GENDER_SUCCESS',
  CHANGE_PIN: 'CHANGE_PIN',
  CHANGE_PIN_SUCCESS: 'CHANGE_PIN_SUCCESS',
  CONFIRM_CODE: 'CONFIRM_CODE',
  CONTACT_FORM_SENT: 'CONTACT_FORM_SENT',
  DELETE_PROFILE: 'DELETE_PROFILE',
  EMAIL_CHANGE: 'EMAIL_CHANGE',
  EMAIL_CHANGE_SUCCESS: 'EMAIL_CHANGE_SUCCESS',
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  EMBED_CODE: 'EMBED_CODE',
  PASSWORD_CHANGE: 'PASSWORD_CHANGE',
  PASSWORD_CHANGE_SUCCESS: 'PASSWORD_CHANGE_SUCCESS',
  PHONE_NUMBER_CHANGE: 'PHONE_NUMBER_CHANGE',
  PHONE_NUMBER_CHANGE_SUCCESS: 'PHONE_NUMBER_CHANGE_SUCCESS',
  PHONE_VERIFICATION: 'PHONE_VERIFICATION',
  PIN_CONFIRMATION: 'PIN_CONFIRMATION',
};
